/* import __COLOCATED_TEMPLATE__ from './lowpass-inductor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();